import Cookies from 'js-cookie'
import { store } from '@/redux/store'
import { resetAuth } from '@/redux/auth/authSlice'

/**
 * Client-side logout utility that clears all authentication data
 * without making an API call
 */
export const clientLogout = () => {
  try {
    store.dispatch(resetAuth())
    Cookies.remove('token')
    localStorage.removeItem('token')
    localStorage.removeItem('auth')

    // Clear sessionStorage
    sessionStorage.removeItem('token')
    localStorage.clear()
    sessionStorage.clear()

    // Redirect to login page
    window.location.href = '/'
  } catch (error) {
    window.location.href = '/'
  }
}
